import { render, staticRenderFns } from "./repairPro.vue?vue&type=template&id=62574954&scoped=true&"
import script from "./repairPro.vue?vue&type=script&lang=js&"
export * from "./repairPro.vue?vue&type=script&lang=js&"
import style0 from "./repairPro.vue?vue&type=style&index=0&id=62574954&scoped=true&lang=css&"
import style1 from "./repairPro.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62574954",
  null
  
)

export default component.exports